import { render, staticRenderFns } from "./DialogItemTrace.vue?vue&type=template&id=5a47f1fa&scoped=true"
import script from "./DialogItemTrace.vue?vue&type=script&lang=js"
export * from "./DialogItemTrace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a47f1fa",
  null
  
)

export default component.exports